import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const StaffService = {
  getList: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}staff`, {params})
}
export default StaffService
